var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_9121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26583 1.6001C8.78436 1.60013 9.28512 1.78901 9.6745 2.13143L9.77717 2.2281L10.2425 2.69343C10.3702 2.82031 10.537 2.9004 10.7158 2.92076L10.8058 2.9261H11.4725C12.0173 2.92607 12.5415 3.13448 12.9375 3.50859C13.3336 3.8827 13.5715 4.39417 13.6025 4.9381L13.6058 5.05943V5.7261C13.6058 5.9061 13.6672 6.08143 13.7778 6.22143L13.8378 6.2881L14.3025 6.75343C14.6876 7.1364 14.9122 7.65184 14.9304 8.19468C14.9486 8.73751 14.7591 9.26685 14.4005 9.67476L14.3038 9.77743L13.8385 10.2428C13.7116 10.3705 13.6315 10.5372 13.6112 10.7161L13.6058 10.8061V11.4728C13.6059 12.0176 13.3975 12.5418 13.0233 12.9378C12.6492 13.3339 12.1378 13.5718 11.5938 13.6028L11.4725 13.6061H10.8058C10.6261 13.6062 10.4516 13.6667 10.3105 13.7781L10.2438 13.8381L9.7785 14.3028C9.39553 14.6879 8.88009 14.9125 8.33725 14.9307C7.79442 14.9489 7.26508 14.7594 6.85716 14.4008L6.7545 14.3041L6.28917 13.8388C6.16146 13.7119 5.99469 13.6318 5.81583 13.6114L5.72583 13.6061H5.05916C4.51435 13.6061 3.99017 13.3977 3.59412 13.0236C3.19807 12.6495 2.96015 12.138 2.92917 11.5941L2.92583 11.4728V10.8061C2.92577 10.6264 2.86518 10.4519 2.75383 10.3108L2.69383 10.2441L2.22917 9.77876C1.84402 9.3958 1.61945 8.88035 1.60124 8.33752C1.58303 7.79469 1.77255 7.26535 2.13117 6.85743L2.22783 6.75476L2.69317 6.28943C2.82004 6.16173 2.90013 5.99496 2.9205 5.8161L2.92583 5.7261V5.05943L2.92917 4.9381C2.95893 4.41506 3.18012 3.92126 3.55056 3.55082C3.921 3.18038 4.4148 2.9592 4.93783 2.92943L5.05916 2.9261H5.72583C5.90558 2.92604 6.08006 2.86545 6.22116 2.7541L6.28783 2.6941L6.75316 2.22943C6.95139 2.03002 7.18708 1.87177 7.44668 1.76376C7.70627 1.65576 7.98466 1.60014 8.26583 1.6001Z",
    fill: "#107A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79999 8.0001L6.93326 10.2666L11.6 5.6001",
    stroke: "#FEFEFE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_9121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.f72ce187.svg";
export { ForwardRef as ReactComponent };